const NODE_BASE_URL = process.env.REACT_APP_NODE_URL
//const NODE_BASE_URL = 'http://localhost:3008';
//const BASE_URL = 'http://192.168.0.216:7003';
const BASE_URL = process.env.REACT_APP_BASE_URL
const SMS_URL = process.env.REACT_APP_INSTANT_SMS
const RCS_URL = process.env.REACT_APP_RCS_URL

const RELOADED_URL = process.env.REACT_APP_RELOADED_BASE



const KAFKA_IVR_PROD_URL = process.env.REACT_APP_IVR_PRODUCER




export const LOGIN_USER = BASE_URL + "/user/login";

export const LOGIN_OUT = BASE_URL + "/user/logout";

export const BARER_TOKEN= "key=AAAAYBBDz5E:APA91bGPW2urX89He6bTH1PxYOx98SbG1dKMvhIT4AwiGxqmsv9voPFkXMgzyotJVazEaGOXBavMGKl713B3j9ugen2J_rjtBa9bN6xXDivaYR1ajaOYn0CSf-Q2MbFvIMGPH5dI3D9o";
 
// Dashboards
export const AGENT_GRAPH = BASE_URL + "/agent/agentgraph";

export const EMAIL_GRAPH = BASE_URL + "/user/emailgraph";
export const ALL_CLIENTS_GRAPH = BASE_URL + "/user/allclientsgraph";


export const DASHBOARD_TOTAL_COUNT = BASE_URL + "/user/dashboard_cnt_client_id";



// MENUS

export const INSERT_MENUS = BASE_URL + "/user/insertmenus";

export const UPDATE_MENUS = BASE_URL + "/user/updatemenus";

export const DELETE_MENU = BASE_URL + "/user/deletemenus";

export const VIEW_MENUS = BASE_URL + "/user/usermenuid";

// ROLES

export const ROLE_LIST = BASE_URL + "/user/viewrolelist";

export const ROLE_LIST_PAGING = BASE_URL + "/user/viewrolegroup";

export const VIEW_ROLE = BASE_URL + "/user/viewroleid";

export const INSERT_ROLE = BASE_URL + "/user/insertrole";

export const UPDATE_ROLE = BASE_URL + "/user/updaterole1";

export const DELETE_ROLE = BASE_URL + "/user/deleterole";

//USER

export const VIEW_USER = BASE_URL + "/user/viewuser";

export const INSERT_USER = BASE_URL + "/user/insertuser";

export const EDIT_USER = BASE_URL + "/user/get_userdtls";

export const DELETE_USER = BASE_URL + "/user/deleteuser";

export const UPDATE_USER = BASE_URL + "/user/updateuser";

export const GET_USER = BASE_URL + "/user/getuser";

export const USER_NAMES_LIST = BASE_URL + "/user/usernameslist";

export const SAVE_GROUP = NODE_BASE_URL + "/api/savegroup";

export const FETCH_GROUP = NODE_BASE_URL + "/api/getgroups";

export const FETCH_GROUP_BY_NAME = NODE_BASE_URL + "/api/getgroupbyname";

export const FETCH_GROUP_NAMES = NODE_BASE_URL + "/api/getallgroup";


export const DELETE_GROUP = NODE_BASE_URL + "/api/deletegroup";



export const WHATSAPP_USER_RESPONSE_EXCEL = NODE_BASE_URL + "/api/whatsappuserresponseexcel";





//IVR 

export const INSERT_IVR_CAMPAIGN = BASE_URL + "/user/uploadivrcsv";

export const IVR_CAMPAIGN_NAMES = BASE_URL + "/user/campaignnamelist";

export const IVR_CAMPAIGN_LIST = BASE_URL + "/user/ivrcampaignlist";

export const IVR_CAMPAIGN_DOWNLOAD = BASE_URL + "/user/downloadivr";

export const IVR_CREATE_CALLFLOW = BASE_URL + "/user/uploadvxml";

export const IVR_CALLFLOW_LIST = BASE_URL + "/user/callflowpagination";

export const IVR_INSTANT = KAFKA_IVR_PROD_URL + "/api/instantivr";

export const IVR_CALLFLOW_NAMES = BASE_URL + "/user/ivrcampaignnames";

export const IVR_CALLFLOW_NAMES_LIST = BASE_URL + "/user/callflowlist";

export const IVR_DAYWISE_REPORT = BASE_URL + "/user/ivrdaywisereports";

export const IVR_DAYWISE_REPORT_EXCEL = BASE_URL + "/user/ivrdaywisedownload";


export const IVR_DETAILED_REPORT = BASE_URL + "/user/ivrdetailedreport";

export const IVR_DETAILED_REPORT_EXCEL = BASE_URL + "/user/ivrdetailedreportexcel";









// EMAILS


export const INSERT_EMAIL_CAMPAIGN = BASE_URL + "/user/uploadcsvemails";

export const EMAIL_CAMPAIGN_NAMES = BASE_URL + "/user/emailslist";

export const EMAIL_CAMPAIGN_LIST = BASE_URL + "/user/emailspagination";

export const EMAIL_CAMPAIGN_DOWNLOAD = BASE_URL + "/user/downloademails";

export const EMAIL_TEMPLATE = BASE_URL + "/user/emailtemplate";

export const EMAIL_INSTANT = BASE_URL + "/user/instantemails";

export const DAYWISE_EMAIL_REPORTS = BASE_URL + "/user/daywisereports";



//SMS
export const SMS_INSTANT = BASE_URL + "/user/instantsms";
export const SMS_SIDS_BY_CLIENT = NODE_BASE_URL + "/api/getSenderidsByClient";
export const SMS_MSG_COUNT = NODE_BASE_URL + "/api/messagecount";
export const SMS_CAMPEIGN_HISTORY= NODE_BASE_URL + "/api/campignhistory";
export const SMS_CAMPEIGN_EXCEL= NODE_BASE_URL + "/api/campaignexcel";
export const TMPLTS_BY_CLIENT = NODE_BASE_URL + "/user/templates";
export const SMS_TMPLTS_SNDRIDS= BASE_URL + "/user/channeltemplates";
//export const SMS_CAMPEIGN_SAVE= NODE_BASE_URL + "/api/sms/savecampign";
export const SMS_CAMPEIGN_SAVE= BASE_URL + "/user/smscreatecampaign";
export const TEMPLATES_BY_CLIENT= BASE_URL + "/user/templatesbyclients";
export const TEMPLATES_APPROVE= BASE_URL + "/user/templateapproval";
export const SUMMARY_REPORT_DAYWISE= BASE_URL + "/user/smsdaywisereports";
export const SUMMARY_REPORT_DAYWISE_EXCEL= BASE_URL + "/user/smsdaywisereports_download";
export const FETCH_SENDER_IDS= BASE_URL + "/user/getsenderid";
export const FETCH_SYSTEM_IDS= BASE_URL + "/user/getsystemid";
export const SMS_DETAILED_REPORT= BASE_URL + "/user/smsdetailedreports";
export const SMS_DETAILED_REPORT_EXCEL = BASE_URL + "/user/smsdetailedreportsexcel";
//WAHTSAPP FALLBACK 
export const SMS_FALLBACK = BASE_URL + "/user/smsfallbackreports";




//export const SEND_SMS= "http://192.168.0.42:8002/sms";
export const SEND_SMS= SMS_URL+"/sms/";
//export const SEND_SMS= "http://192.168.0.42:2011/sms";
//export const SEND_SMS= "http://converge-now.com:2011/sms";













//RCS

export const RCS_TEXT = BASE_URL + "/user/textmsg";
export const RCS_RICHCARD = BASE_URL + "/user/richcard";
export const RCS_IMAGE = BASE_URL + "/user/imageurl";
export const RCS_DIALACTION = BASE_URL + "/user/dialaction";
export const RCS_VIEWLOCATION = BASE_URL + "/user/viewlocation";
export const RCS_OPEN_URL = BASE_URL + "/user/openurl";
export const RCS_SHARE_LOCATION = BASE_URL + "/user/sharelocation";
export const RCS_CALENDAR_EVENT = BASE_URL + "/user/calendarevent";
export const RCS_CAROUSEL_CARD = BASE_URL + "/user/carouselcard";
export const RCS_CAMPAIGN = BASE_URL + "/user/rcscreatecampaign";
export const RCS_CAMPAIGN_LIST = BASE_URL + "/user/rcscampaignlist";
export const RCS_DAYWISE_REPORT = BASE_URL + "/user/rcsdaywisereports";
export const RCS_DAYWISE_REPORT_EXCEL = BASE_URL + "/user/rcsdaywisedownload";
export const RCS_DRTAILED_REPORT = BASE_URL + "/user/rcsdetailedreport";
export const RCS_DRTAILED_REPORT_EXCEL = BASE_URL + "/user/rcsdetailedreportexcel";

//export const sendRcs = "http://192.168.0.162:7073/rcs_info/";

export const INSTANT_RCS = RCS_URL + "/rcs_info";









//export const RCS_INSTANT = BASE_URL + "/user/uploadcsvrcs";

export const RCS_CLIENT_ID = "117543218154143299807";




//Whatsapp
export const WHATSAPP_INSTANT = BASE_URL + "/user/sendwhatsapp";
//export const WHATSAPP_INSTANT = BASE_URL + "/user/instantwhatsapp";


//export const INSERT_WHATSAPP_CAMPAIGN = BASE_URL + "/user/uploadcsvwhatsup";
export const INSERT_WHATSAPP_CAMPAIGN = BASE_URL + "/user/whatsappcreatecampaign";

export const WHATSAPP_CAMPAIGN_LIST = BASE_URL + "/user/whatsappcampaignlist";

export const WHATSAPP_CAMPAIGN_DELETE = BASE_URL + "/user/whatsappcampaignstatus";

export const WHATSAPP_CAMPAIGN_LIST_DATE = BASE_URL + "/user/whatsappallcampaigns";

export const WHATSAPP_CATEGORY_SUMMARY = BASE_URL + "/user/whatsappcategorysummary";

export const WHATSAPP_EMBED_TEMPLATE = BASE_URL + "/user/metaembedtemplate";

export const WHATSAPP_HEADER_HANDLE= BASE_URL + "/user/whatsapp_header_handle";

export const WHATSAPP_CAROUSEL_IMG_ID= BASE_URL + "/user/whatsapp_media_carousel";

export const WHATSAPP_OvERVIEW= BASE_URL + "/user/whatsappcampaigncount";













export const WHATSAPP_CAMPAIGN_NAMES = BASE_URL + "/user/whatsuplist";

//export const WHATSAPP_CAMPAIGN_LIST = BASE_URL + "/user/whatsuppagination";

export const WHATSAPP_CAMPAIGN_DOWNLOAD = BASE_URL + "/user/downloadwhatsup";

export const WHATSAPP_TEMPLATE = BASE_URL + "/user/whatsuptemplate";

export const DAYWISE_WHATSAPP_REPORTS = BASE_URL + "/user/whatsupdaywisereports";

export const DAYWISE_WHATSAPP_REPORTS_EXCELL = BASE_URL + "/user/whatsupdaywisedownload";

export const META_TEMPLATES = BASE_URL + "/user/metaembedtemplatelist";

export const META_TEMPLATE_STATUS = BASE_URL + "/user/metatemplatestatus";

export const ALL_META_TEMPLATES = BASE_URL + "/user/viewallmetatemplate";



//export const DAYWISE_WHATSAPP_REPORTS = NODE_BASE_URL + "/api/whatsupdaywisereports";

//export const DAYWISE_WHATSAPP_REPORTS_EXCELL = NODE_BASE_URL + "/api/whatsupdaywisereportsxcell";



export const WHATSAPP_DETAIL_REPORTS = BASE_URL + "/user/whatsappdetailedreportsdate";

export const WHATSAPP_CHAT_HISTORY = BASE_URL + "/user/tempagentuserchat";



export const WHATSAPP_ALL_TEMPLATES = BASE_URL + "/user/whatsappalltemplates";


export const WHATSAPP_GRAPH = BASE_URL + "/user/whatsupgraph";

export const Whatsapp_CAMPAIGN_REPORTS = BASE_URL + "/user/allcampaignreport";

export const WHATSAPP_DAYWISE_EXCEL = BASE_URL + "/user/campaigndownloadexcel";

export const WHATSAPP_USER_RESPONSE = BASE_URL + "/user/whatsappuserresponse";

export const CAMPAIGN_LIST = BASE_URL + "/user/whatsapp_campaignlist";

export const CAMPAIGN_LIST_BY_CAMPAGIN = BASE_URL + "/user/whatsapp_campaign_status_counts";

export const CAMPAIGN_LIST_BY_CAMPAGIN_STATUS_EXCEL = BASE_URL + "/user/whatsapp_campaign_status_excel";

//export const WHATSAPP_USER_RESPONSE_EXCEL = BASE_URL + "/user/whatsappuserresponseexcel";



//export const WHATSAPP_LOG_EXCEL = BASE_URL + "/user/downloaddata";
export const WHATSAPP_LOG_EXCEL = BASE_URL + "/user/clnthistorydata";
export const SMS_LOG_EXCEL = BASE_URL + "/user/clnthistorydata";

//WAHTSAPP FALLBACK 
export const WHATSAPP_FALLBACK = BASE_URL + "/user/whatsappfallbackreports";

//CHAT HISTORY LIST 
export const CHAT_HISTORY = BASE_URL + "/user/client_chatlist";
//VIEW COMPLETE CHAT HISTORY
export const COMPLETE_CHAT_HISTORY = BASE_URL + "/user/client_chatinfo";
//VIEW COMPLETE CHAT HISTORY COUNT
export const COMPLETE_CHAT_COUNT = BASE_URL + "/user/client_chatcount";









//Live Agent

export const AGENT_LIST = BASE_URL + "/agent/agentslist";

export const AGENT_CHAT_LIST = BASE_URL + "/agent/agentchat";

export const AGENT_CHAT_HISTORY = BASE_URL + "/agent/agentchathistory";

export const AGENT_TRANSFER = BASE_URL + "/agent/usertransfer";

export const SYNC_CHAT = BASE_URL + "/agent/userinfosync";

export const RE_CHAT = BASE_URL + "/agent/agentusr24chat";




//export const BASE_URL_CHAT_APP = 'https://whatsappui.netxcell.com:9002';
//export const BASE_URL_CHAT_APP = 'http://192.168.0.42:7001';
//export const BASE_URL_CHAT_APP = 'http://192.168.1.78:8087';
//export const BASE_URL_CHAT_APP = 'http://chatbot.netxcell.com:8087';

//export const BASE_URL_CHAT_WHATSAPP = 'https://whatsappui.netxcell.com:8090';
//export const BASE_URL_CHAT_WHATSAPP = 'https://whatsappui.netxcell.com:8373';
export const BASE_URL_CHAT_APP = process.env.REACT_APP_CHAT_APP
export const BASE_URL_CHAT_WHATSAPP = process.env.REACT_APP_WHATSAPP_CHAT


//export const  SOCKET_URL = "ws://192.168.1.78:3001";
//export const  SOCKET_URL = "https://whatsappui.netxcell.com:9001"
//export const  SOCKET_URL = "https://whatsappui.netxcell.com:9001"
//export const  SOCKET_URL = "http://192.168.0.42:3001"
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL


// Client Apis

//export const INSERT_CLIENT = BASE_URL + "/user/insertclient";
 export const INSERT_CLIENT = NODE_BASE_URL + "/api/saveclient";
//export const INSERT_CLIENT =  "http://192.168.0.216:7003/user/insertclient";
//export const UPDATE_CLIENT = BASE_URL + "/user/updateclient";
export const UPDATE_CLIENT = NODE_BASE_URL + "/api/updateclient";

export const DELETE_CLIENT = NODE_BASE_URL + "/api/deleteclient";
//export const DELETE_CLIENT = BASE_URL + "/user/deleteclient";

export const VIEW_CLIENT = BASE_URL + "/user/clientid";
export const CLIENT_LIST = BASE_URL + "/user/clientlist";
export const CLIENT_GATEWAY_LIST = BASE_URL + "/user/gatewayproviders";

//export const VIEW_CLIENT_LIST = BASE_URL + "/user/viewclient";
export const VIEW_CLIENT_LIST = NODE_BASE_URL + "/api/clientlist";
export const ALL_CLIENT_LIST = NODE_BASE_URL + "/api/allclientlist";
export const CLIENT_BY_ID = NODE_BASE_URL + "/api/getclientbyid";

export const CLIENT_API = NODE_BASE_URL + "/api/getClient";

// Channel Module

export const INSERT_CLIENT_CHANNELS = NODE_BASE_URL + "/api/saveclientChannels";

export const CHANNELS_BY_CLIENT = NODE_BASE_URL + "/api/channelsbyclient";

export const CHANNELS_BY_ID = NODE_BASE_URL + "/api/getChannelById";

export const UPDATE_CHANNELS = NODE_BASE_URL + "/api/updateChannel";

export const DELETE_CHANNEL = NODE_BASE_URL + "/api/deletechannel";

export const PENDING_CHANNELS = NODE_BASE_URL + "/api/pendingChannels";

export const CHANNEL_TEMPLATES_APPROVE= NODE_BASE_URL + "/api/templateapproval";

export const CHANNEL_CLIENT_CHNLTYPE= NODE_BASE_URL + "/api/channelbyclnttype";

export const APPROVED_CHANNELS= NODE_BASE_URL + "/api/approvedchannels";


//Configuration

export const INSERT_PULSE= NODE_BASE_URL + "/api/savePulse";
export const UPDATE_PULSE= NODE_BASE_URL + "/api/updatePulse";
export const FETCH_ALL_PULSE= NODE_BASE_URL + "/api/getAllpulse";
export const FETCH_PULSE_ID = NODE_BASE_URL + "/api/getPulseById";
export const DELETE_PULSE= NODE_BASE_URL + "/api/deletePulse";

export const INSERT_CREDITS= NODE_BASE_URL + "/api/saveCredits";
export const UPDATE_CREDITS= NODE_BASE_URL + "/api/updateCredits";
export const FETCH_ALL_CREDITS= NODE_BASE_URL + "/api/getAllCredits";
export const FETCH_CREDITS_ID = NODE_BASE_URL + "/api/getCreditsById";
export const DELETE_CREDITS = NODE_BASE_URL + "/api/deleteCredits";
//export const CREDITS_BALANCE = NODE_BASE_URL + "/api/getCreditsBalance";
export const CREDITS_BALANCE = BASE_URL + "/user/downloaddata";

export const CREDITS_BALANCE_CLIENT = NODE_BASE_URL + "/api/getCrdtsBalanceByClient";

export const BALANCE_CLIENT_CHNL = NODE_BASE_URL + "/api/fetchbalancebychnlclnt";

export const BALANCE_CLIENT_CHNL_RESELLER = BASE_URL + "/user/reseller_balance";




export const CREDITS_BALANCE_REDIS = BASE_URL + "/user/redis_balance";




















//WORK FLOW MENU

export const UPLOAD_WORK_FLOW = BASE_URL + "/chatbot/insertschema"
export const CHNL_BY_SENDER = BASE_URL + "/chatbot/getsenderid"
export const SCEMA_BY_ID = BASE_URL + "/chatbot/getschemadata"

export const USER_RELOAD = SMS_URL+"/loadaccountsinfo"



//Get Cout


export const GET_COUNT = BASE_URL + "/user/get_count"


export const ROLE_AGENT=1;

export const ROLE_ADMIN=2;

export const ROLE_SUPER_ADMIN=3;

export const ROLE_SUPER_ADMIN_NAME="Super Admin";

export const TRANSC_CREDIT = 1;
export const TRANSC_DEBIT  = 2;


















  
